import React, { useEffect, useRef } from "react";
import { Navbar } from "@/components/Navbar";
import { Marquee } from "@/components/Marquee";
import { Hero } from "@/components/Hero";
import { Countdown } from "@/components/Countdown";
import { AboutSection } from "@/components/AboutSection";
import { Shop } from "@/components/Shop";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { MusicPlayer } from "@/components/MusicPlayer";
import { Snowfall } from "@/components/Snowfall";
import { TwinkleLights } from "@/components/TwinkleLights";
import { useCart } from "@/context/CartContext";
import { getCheckoutStatus } from "@/lib/api";
import { toast } from "sonner";

export default function Home() {
  const { clear } = useCart();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    const params = new URLSearchParams(window.location.search);
    const checkout = params.get("checkout");
    const sessionId = params.get("session_id");

    if (checkout === "cancel") {
      handled.current = true;
      toast.error("Payment cancelled. Your cart is still here.");
      window.history.replaceState({}, "", window.location.pathname);
      return;
    }

    if (checkout === "success" && sessionId) {
      handled.current = true;
      const poll = async (attempt = 0) => {
        if (attempt === 0) toast.loading("Confirming your payment…", { id: "pay" });
        try {
          const res = await getCheckoutStatus(sessionId); 
          if (res.payment_status === "paid") {
            toast.success("Payment received — thank you, bandit! 🍭", { id: "pay" });
            clear();
            return;
          }
          if (res.status === "expired") {
            toast.error("Payment session expired.", { id: "pay" });
            return;
          }
          if (attempt >= 6) {
            toast.info("Still processing. Check your email for confirmation.", { id: "pay" });
            return;
          }
          setTimeout(() => poll(attempt + 1), 2000);
        } catch {
          toast.error("Could not verify payment.", { id: "pay" });
        }
      };
      poll();
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [clear]);

  return (
    <div className="App haunted-bg">
      <Snowfall />
      <Navbar />
      <div className="relative z-10">
        <TwinkleLights />
        <Countdown />
        <Marquee />
        <Hero />
        <Marquee bg="bg-candy-teal" />
        <AboutSection />
        <Shop />
        <ContactSection />
        <Footer />
      </div>
      <CartDrawer />
      <MusicPlayer />
    </div>
  );
}
